// src/app/core/http/timeout.interceptor.ts
import type {
  HttpInterceptorFn, HttpRequest, HttpHandlerFn} from '@angular/common/http';
import {
  HttpErrorResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { TimeoutError } from 'rxjs';
import { ConfigService } from '../config/config.service';

/**
 * TimeoutInterceptor — aplica un deadline global a todas las peticiones HTTP.
 *
 * Si el servidor no responde en api.timeoutMs milisegundos:
 * - RxJS lanza TimeoutError
 * - El interceptor lo convierte en HttpErrorResponse con status 408
 * - El ErrorInterceptor captura el 408 y muestra 'common.errors.timeout'
 */
export const timeoutInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const config = inject(ConfigService);
let timeoutMs = 30000; // fallback mientras el config no esté disponible
try {
  timeoutMs = config.get('api').timeoutMs;
} catch {
  // Config aún no cargado (petición del APP_INITIALIZER) — usar fallback
}

  return next(req).pipe(
    timeout(timeoutMs),
    catchError((error: unknown) => {
      if (error instanceof TimeoutError) {
        // Convertir TimeoutError en HttpErrorResponse 408 para que
        // ErrorInterceptor lo maneje de forma uniforme con otros errores HTTP
        const timeoutError = new HttpErrorResponse({
          error:      'Timeout: la solicitud tardó demasiado',
          status:     408,
          statusText: 'Request Timeout',
          url:        req.url,
        });
        return throwError(() => timeoutError);
      }
      return throwError(() => error);
    })
  );
};
